import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//declare let paypal: any;


@Component({
  selector: 'app-hadmin',
  templateUrl: './hadmin.component.html',
  styleUrls: ['./hadmin.component.css']
})
export class HadminComponent implements OnInit {



  //addScript: boolean = false;
  //paypalLoad: boolean = true;

  //finalAmount: number = 1;

  //paypalConfig = {
  //  env: 'sandbox',
  //  client: {
  //    sandbox: 'AWl20nuW6HkAmA1sSxsTvSjLN8e-A5SVffOzkZmpyDUcv69u7fwbXDJ8',
  //    production: '<your-production-key here>'
  //  },
  //  commit: true,
  //  payment: (data, actions) => {
  //    return actions.payment.create({
  //      payment: {
  //        transactions: [
  //          { amount: { total: this.finalAmount, currency: 'INR' } }
  //        ]
  //      }
  //    });
  //  },
  //  onAuthorize: (data, actions) => {
  //    return actions.payment.execute().then((payment) => {
  //      //console.log(payment);
  //      //Do something when payment is successful.
  //    })
  //  }
  //};

  //ngAfterViewChecked(): void {
  //  if (!this.addScript) {
  //    this.addPaypalScript().then(() => {
  //      paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
  //      this.paypalLoad = false;
  //    })
  //  }
  //}

  //addPaypalScript() {
  //  this.addScript = true;
  //  return new Promise((resolve, reject) => {
  //    let scripttagElement = document.createElement('script');
  //    scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
  //    scripttagElement.onload = resolve;
  //    document.body.appendChild(scripttagElement);
  //  })
  //}

  constructor(private router: Router) { }

  ngOnInit(): void {

  }



 


}
